<template>
<DashBoardLayout :showNavbar=true :isSearch=false >
    <div class="w100">
        <v-tabs>
            <v-tab @click="PendingOrders()">Pending Orders</v-tab>
            <v-tab @click="HistoryOrders()">Order History</v-tab>
        </v-tabs>

        <div class="row">
            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 ">
                <div class="show-product-wrap product position-relative" v-for="item in orderList" :key="item.category" :loading="loading">
                    <router-link :to="'/orderDetails?'+item.order_id" class="col-xl-11 bg_white col-lg-11 col-11 product-show-wrap auto sh3 mb-3 position-relative order-app-wrap"><span class="date-app-wrap">{{item.date_of_order}}</span>
                        <div class="c-wrap position-relative p-3">
                            <h2 class="product-h">Order #{{item.order_id }}</h2>
                            <div class="w100"> <span class="packing-p">Status : <span>{{item.order_status}}</span>
                                    <!-- <div><span>{{item.product_name}}-{{item.quantity}}</span></div> -->
                                </span>
                            </div> <span class="p-price">Total : ₹ {{item.camount}}/-
                            </span>
                        </div>
                    </router-link>
                    <div class="add-to-cart cta-atc-wrap pr-2">
                        <input type="hidden" class="product_id" value="11">
                        <button v-if="order_status=='Pending' && item.order_status=='Ordered'" class="p-cta-btn" @click="cancelOrder(item.order_id,$event)">Cancel Order</button>
                        <button v-if="order_status=='History'" @click="reOrder(item.order_id)" class="p-cta-btn">Re-Order</button>
                    </div>

                </div>

            </div>

            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12" v-if="orderCount == 0">
                <div class="show-product-wrap product position-relative" :loading="loading">
                    <div class="col-xl-11 bg_white col-lg-11 col-11 product-show-wrap auto sh3 mb-3 position-relative order-app-wrap">
                        <div class="c-wrap position-relative p-3">
                            <h2 class="product-h">No Order Found</h2>
                             
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</DashBoardLayout>
</template>

<script>
import axios from "axios"
import ApiList from '../ApiList'
import globalMixins from '../globalMixins'
import DashBoardLayout from '../../layouts/DashboardLayout.vue'
export default {
    name: 'MyOrders',
    mixins: [ApiList, globalMixins],
    data() {
        return {
            loading: false,
            newUrl: "",
            orderList: [],
            orderItems: [],
            order_status: "Pending",
            reOrderResponse: [],
            reOrderProductIds: [],
            cart: [],
            orderCount : 0,

        }
    },
    // created(){
    //     this.$emit(`update:layout`,DashBoardLayout)
    // },
    components: {
        DashBoardLayout
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.checkSession();
            this.cart = JSON.parse(localStorage.getItem("cart"));
            this.newUrl = this.apis.apiUrl + this.apis.ordersUrl;
            this.customer_id = localStorage.customer_id;
            this.param = {
                params: {
                    token: localStorage.token,
                    order_status: this.order_status,
                    customer_id: this.customer_id
                }
            }
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    console.log(response)
                    this.orderList = []
                    this.orderList = response.data
                    this.orderCount = response.data.length
                    // console.log(respons  e.data); 
                })
        },
        PendingOrders() {
            this.order_status = "Pending"
            this.loadData()
        },
        HistoryOrders() {
            this.order_status = "History"
            this.loadData()
        },
        reOrder(orderid) {
            this.newUrl = this.apis.apiUrl + this.apis.repeatOrderUrl
            this.param = {
                params: {
                    order_id: orderid,
                    token: localStorage.token
                }
            }
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    // console.log(response)
                    this.reOrderProductIds = [];
                    for (var x = 0; x < response.data.length; x++) {
                        this.reOrderProductIds.push(response.data[x].product_id);
                    }
                    var product_data = btoa(JSON.stringify(this.reOrderProductIds));

                    this.param = {
                        params: {
                            token: localStorage.token,
                            product_data: product_data
                        }
                    }
                    this.newUrl = this.apis.apiUrl + this.apis.productPriceUrl
                    axios.get(this.newUrl, this.param)
                        .then((response) => {
                            console.log(response.data)
                            this.orderItems = response.data
                            if(this.cart!=null)
                                this.cart.splice(0, this.cart.length)
                            var index = 0
                            for (index = 0; index < this.orderItems.length; index++) {
                                this.addToCart(this.orderItems[index].product_id, this.orderItems[index].name, this.orderItems[index].discount_price, this.orderItems[index].packing, this.orderItems[index].measure_unit)

                            }
                            this.$router.push({ name: 'Home' })
                        });
                });

        },
        cancelOrder(order_id, event) {
            console.log(order_id);
            this.newUrl = this.apis.apiUrl + this.apis.cancelOrderUrl;
            this.param = {
                params: {
                    token: localStorage.token,
                    order_id: order_id,
                    status: 'Cancelled'
                }
            }
            axios.get(this.newUrl, this.param)
                .then(async response => {
                    this.orderResponse = response.data;
                    if (response.data.error == 0) {
                        // console.log(event.target.parentElement.parentElement)
                        event.target.parentElement.parentElement.style.display = "none"
                    }
                    console.log(this.orderResponse);
                    // console.log(this.showPendingOrders);
                });
        },

    }
}
</script>
